// Helpers puros do bloco "Quem está contratando" (épico PO1-3527). A regra de
// visibilidade mora no backend; aqui só formatação e checagens de tela.

export function soDigitos(v) {
  return String(v == null ? "" : v).replace(/\D/g, "");
}

// Tira o 55 do país quando veio junto (12 ou 13 dígitos), para exibir.
export function digitosNacionais(v) {
  const d = soDigitos(v);
  if ((d.length === 12 || d.length === 13) && d.indexOf("55") === 0) return d.slice(2);
  return d;
}

// (47) 99999-8888 / (47) 3333-4444; fora do padrão, devolve os dígitos.
export function fmtTelefone(v) {
  const d = digitosNacionais(v);
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return d;
}

// Mesma regra do backend: https://wa.me/55<dígitos>, sem repetir o 55.
export function linkWhatsapp(v) {
  const d = soDigitos(v);
  if (!d) return null;
  if ((d.length === 12 || d.length === 13) && d.indexOf("55") === 0) return `https://wa.me/${d}`;
  return `https://wa.me/55${d}`;
}

// Telefone e WhatsApp valem com 10 a 13 dígitos (vazio é permitido).
export function telefoneValido(v) {
  const d = soDigitos(v);
  return d.length === 0 || (d.length >= 10 && d.length <= 13);
}

// true quando há algo além do cabeçalho para desenhar.
export function temConteudo(perfil) {
  if (!perfil) return false;
  return Boolean(
    perfil.nome ||
      perfil.razaoSocial ||
      perfil.apresentacao ||
      (perfil.contato && (perfil.contato.nome || perfil.contato.email)) ||
      (perfil.indicadores && perfil.indicadores.length),
  );
}

export const LIMITE_CIDADES_ORIGEM = 20;
